import { desktopApi } from './desktopApi';
import { deleteReportPhoto, listReportPhotos } from './offlineStore';
import { photosForReport, uploadTaggedKeepingMissing } from './reportPhotoQueue.mjs';

function asFile(photo) {
  const type = photo.contentType || 'image/jpeg';
  if (typeof File === 'function' && photo.blob instanceof Blob) {
    return new File([photo.blob], 'ronde.jpg', { type });
  }
  return photo.blob;
}

async function sendOne(photo) {
  if (!photo.reportId) throw new Error('Photo sans rapport');
  await desktopApi.uploadReportPhoto(photo.reportId, asFile(photo));
  await deleteReportPhoto(photo.id);
}

/** Envoie les photos déjà liées à un rapport, sans recréer le rapport.

Une photo posée avant la création du rapport répond 404 : elle reste en file
et n'empêche pas l'enregistrement du texte.
*/
export async function uploadTaggedPhotos(agentId) {
  const photos = await listReportPhotos(agentId);
  await uploadTaggedKeepingMissing(photos, sendOne);
}

/** Envoie uniquement les photos de ce rapport.

Une photo sans identifiant, ou liée à un autre rapport, n'est pas réattribuée.
*/
export async function uploadQueuedPhotos(agentId, reportId) {
  const pending = photosForReport(await listReportPhotos(agentId), reportId);
  for (const photo of pending) {
    await sendOne(photo);
  }
}
